import { render, staticRenderFns } from "./DictionaryText.vue?vue&type=template&id=19cccd3e&scoped=true&"
import script from "./DictionaryText.vue?vue&type=script&lang=js&"
export * from "./DictionaryText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cccd3e",
  null
  
)

export default component.exports